import { normalize } from "normalizr";
import { camelizeKeys } from "humps";
import api from "./api";
import { showError } from "actions/actionCreators/snackbarActions";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import schemas from "utils/schemas";

export function loadFinancedOffers(documentId, siteId) {
  return async (dispatch, getState) => {
    const item = getState().currentFolder.financedOffers;
    let shouldCallApi = !item || (!item.isLoaded && !item.loading);

    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_FINANCED_OFFERS_STARTED });

    try {
      const response = await dispatch(sendHttpRequest(api.getFinancedOffers(documentId, siteId)));
      const camelizedJson = camelizeKeys(response);

      const payload = Object.assign({}, normalize(camelizedJson, [schemas.financedOffer]));

      dispatch({ type: actionTypes.LOAD_FINANCED_OFFERS_SUCCEEDED, ...payload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FINANCED_OFFERS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadFolderOfferPartners(documentId, siteId) {
  return async (dispatch, getState) => {
    const item = getState().currentFolder.offerPartners;
    let shouldCallApi = !item || (!item.isLoaded && !item.loading);

    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_FOLDER_OFFER_PARTNERS_STARTED });

    try {
      const response = await dispatch(sendHttpRequest(api.getFolderOfferPartners(documentId, siteId)));
      const camelizedJson = camelizeKeys(response);

      const payload = Object.assign({}, normalize(camelizedJson, [schemas.offerPartner]));
      dispatch({ type: actionTypes.LOAD_FOLDER_OFFER_PARTNERS_SUCCEEDED, ...payload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_FOLDER_OFFER_PARTNERS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadClientOffers(clientId) {
  return async (dispatch, getState) => {
    const item = getState().currentFolder.clientOffers;

    let shouldCallApi = !item || (!item.isLoaded && !item.loading);

    if (!shouldCallApi) return;

    dispatch({ type: actionTypes.LOAD_CLIENT_OFFERS_STARTED });

    try {
      const response = await dispatch(sendHttpRequest(api.getClientOffers(clientId)));
      const camelizedJson = camelizeKeys(response);

      const payload = Object.assign({}, normalize(camelizedJson, [schemas.clientOffer]));

      dispatch({ type: actionTypes.LOAD_CLIENT_OFFERS_SUCCEEDED, ...payload });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CLIENT_OFFERS_FAILED, error });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function updateFinancedOffersOnFolder(documentId, siteId, isRemoveOffersMode, selectedOffers) {
  return async dispatch => {
    dispatch({
      type: actionTypes.SAVE_FOLDER_FINANCED_OFFERS_STARTED,
      payload: { documentId, siteId, isRemoveOffersMode, selectedOffers }
    });
    dispatch(
      sendHttpCommandAndWaitForEvent(
        api.updateFinancedOffersOnFolder(documentId, siteId, isRemoveOffersMode, selectedOffers),
        "UpdateFinancedOffersOnFolder",
        [eventTypes.FOLDER_FINANCED_OFFERS_UPDATED]
      )
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: actionTypes.SAVE_FOLDER_FINANCED_OFFERS_SUCCEEDED,
            payload: { documentId, siteId, selectedOffers }
          });
        } else {
          dispatch({
            type: actionTypes.SAVE_FOLDER_FINANCED_OFFERS_FAILED,
            payload: { documentId, siteId, selectedOffers, error: event }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.SAVE_FOLDER_FINANCED_OFFERS_FAILED,
          payload: { documentId, siteId, selectedOffers, error }
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function blockFacilitySublimitAmountManually(documentId, siteId, documentTypeCode) {
  return async dispatch => {
    dispatch({
      type: actionTypes.BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_STARTED,
      payload: { documentId, siteId }
    });
    dispatch(
      sendHttpCommandAndWaitForEvent(
        api.blockFacilitySublimitAmountManually(documentId, siteId, documentTypeCode),
        "BlockFacilitySublimitAmountManually",
        [eventTypes.BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_EXECUTED],
        true
      )
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: actionTypes.BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_SUCCEEDED,
            payload: { documentId, siteId }
          });
        } else {
          dispatch({
            type: actionTypes.BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_FAILED,
            payload: { documentId, siteId }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: actionTypes.BLOCK_FACILITY_SUBLIMIT_AMOUNT_MANUALLY_FAILED,
          payload: { documentId, siteId }
        });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}
